import React from "react";
import {Col, FormGroup, Label} from "reactstrap";
import {PADDING_STYLE} from "./CreateObjectLabel";

import {ResponsiveHelper, ResponsiveSize} from "../utils/ResponsiveHelper";

const LABEL_CONFIG = {
  md: {size: 12},
  xl: {size: 5}
};
const VALUE_CONFIG = {
  md: {size: 12},
  xl: {size: 7}
};
export const LABEL_STYLE = { fontWeight: "bold"};
export default class CreateObjectRowWithLabelComponent extends React.Component {
  render() {

    let rightAlign = true;
    if (ResponsiveHelper.isSmallerThan(window.responsiveSize, ResponsiveSize.XL)) {
      rightAlign = false;
    }

    let className = this.props.className;
    let labelStyle = this.props.labelStyle || LABEL_STYLE;

    labelStyle = {
      ...labelStyle,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "100%"
    };
    if (rightAlign && this.props.className === undefined) {
      labelStyle.textAlign = "right";
      className = "float-md-right"
    }
    let colStyle = PADDING_STYLE;
    colStyle = {
      ...colStyle,
    };


    return <FormGroup row>
      <Col {...LABEL_CONFIG}
           style={colStyle}
      >
        <Label className={className}
               style={labelStyle}
               title={this.props.title || this.props.label}
        >{this.props.label}</Label>
      </Col>
      <Col {...VALUE_CONFIG}>
        {this.props.children}
      </Col>
    </FormGroup>;
  }
}
